export const SERVICE_NAMES: TStringObject = {
  top3: 'Топ',
  'premium+highlight': 'Премиум',
  premium: 'Премиум',
  'paid+highlight': 'Платное',
  paid: 'Платное',
  free: 'Бесплатное',
};
